/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const locationSearchNodes = Array.from(document.querySelectorAll('.location-search'));
if (locationSearchNodes.length) {
    import(/* webpackChunkName: "LocationSearch" */ './components/LocationSearch').then(({ default: LocationSearch }) => {
        locationSearchNodes.forEach((node) => {
            const locationSearchComponent = node.querySelector('.location-search__component');
            const locationSearchMap = node.querySelector('.location-search__map');
        
            render(<LocationSearch {...parseDataToProps(locationSearchComponent.dataset)} locationSearchMapContainer={locationSearchMap} />, locationSearchComponent);
        });
    });
}
